import Swiper from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";

function initSliderCampus(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".swiper-campus").forEach((el) => {
		const blockSliderCampus = el.closest(".wp-block-acf-bloc-campus");
		if (!blockSliderCampus) return;

		const swiper = new Swiper(el, {
			modules: [Navigation, Pagination, A11y],
			slidesPerView: 3.5,
			centeredSlides: true,
			spaceBetween: 25,
			loop: true,
			speed: 700,
			pagination: {
				el: blockSliderCampus.querySelector(".bloc-slider-campus__pagination"),
				clickable: true,
			},
			navigation: {
				prevEl: el.querySelector(".swiper-button-prev"),
				nextEl: el.querySelector(".swiper-button-next"),
			},
			breakpoints: {
				0:    { slidesPerView: 1,   spaceBetween: 12 },
				640:  { slidesPerView: 2.5, spaceBetween: 25 },
				1024: { slidesPerView: 3.5, spaceBetween: 25 },
			},
		});

		const clearHighlight = () => {
			el.querySelectorAll(".swiper-slide.--card-campus-highlight").forEach(
				(s) => s.classList.remove("--card-campus-highlight"),
			);
		};

		const activateSvgCity = (city) => {
			blockSliderCampus.querySelectorAll(".bloc-campus-map g[id]").forEach((g) => {
				g.classList.toggle("city-active", g.id.toUpperCase() === city);
			});
		};

		const syncCity = () => {
			const slide = swiper.slides[swiper.activeIndex];
			const city = slide?.dataset.city;
			if (city) activateSvgCity(city);
		};


		swiper.on("slideChange", () => {
			clearHighlight();
			syncCity();
		});

		swiper.on("afterInit", () => syncCity());

		const goToCity = (city) => {
			const target = [...el.querySelectorAll(".swiper-slide")]
				.find((s) => s.dataset.city === city);
			if (!target) return;

			const index = parseInt(target.dataset.swiperSlideIndex, 10);

			clearHighlight();
			target.classList.add("--card-campus-highlight");
			activateSvgCity(city);
			swiper.slideToLoop(index);
		};

		blockSliderCampus.querySelectorAll(".bloc-campus-map g[id]").forEach((city) => {
			city.style.cursor = "pointer";
			city.addEventListener("mouseenter", () => goToCity(city.id.toUpperCase()));
			city.addEventListener("click", () => goToCity(city.id.toUpperCase()));
		});
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderCampus());

// Gutenberg / ACF editor — $block est scopé au document réel du bloc (canvas iframé ou non)
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-campus", ($block) => {
		const el = $block && $block.jquery ? $block.get(0) : $block;
		initSliderCampus(el);
	});
}
